import { FeatureMainProps } from '../../../../components/Features/FeatureMain/types'

export const pageData: FeatureMainProps = {
    accentColor: '#b08d4a',
    pc: {
        background: '/features/palace-20260706/hero.jpg',
        eyebrow: '求人特集',
        titleLines: ['パレスホテル', '大宮'],
        contentsColor: '#1f4a7a',
    },
    hero: {
        image: '/features/palace-20260706/hero.jpg',
        alt: 'パレスホテル大宮',
        panel: '/features/palace-20260706/hero_panel.png',
        analyticsLabel: 'FV',
    },
    headline: {
        title: [
            { text: '「新たな価値」', accent: true },
            { text: 'を見出せるホテルへ', breakBefore: true },
        ],
        paragraphs: [
            {
                text: '1階レストランフロアを、大箱のカフェ・オールデイダイニングへリニューアルする一大プロジェクト',
            },
            {
                text: '大宮で愛されてきたホテルの新しい歴史を、一緒につくりませんか。',
                breakBefore: true,
            },
        ],
    },
    thumbnail: {
        image: '/features/palace-20260706/top_sub.jpg',
        alt: 'パレスホテル大宮',
    },
    featuresTitle: ['パレスホテル大宮', 'で働く魅力'],
    featuresTitleAnalyticsLabel: 'CT_Charm_働く魅力-タイトル',
    features: [
        {
            heading: ['老舗企業としての安定性'],
            body: [
                '母体であるパレスホテル株式会社は創業から60年以上、ホテル事業だけでなくレストランや不動産など様々な事業をおこなっている老舗企業です。パレスホテル大宮では新しいことにチャレンジしていますが、こうしたことができるのも安定した経営基盤があるからこそです。',
            ],
            image: '/features/palace-20260706/section_01.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-1st',
        },
        {
            heading: ['新しい歴史を作るプロジェクトに携われる'],
            body: [
                '1階のレストランフロアを新しくする一大プロジェクトをゼロから作り上げていく経験を積むことができ、新しいことにチャレンジできる楽しさ、そしてさらなるスキルアップもできます。',
            ],
            image: '/features/palace-20260706/section_02.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-2nd',
        },
        {
            heading: ['アクセス良好で始業時間の相談可'],
            body: [
                '「大宮に根付いたホテル」と自負していえるのは、やはりアクセスの良さが理由の一つ。',
                'JR大宮駅西口より徒歩3分、そして大宮駅は在来線が8路線もあるターミナル駅です。',
                'これはお客様だけでなく、働いている社員・スタッフにとっても嬉しいことです。',
            ],
            image: '/features/palace-20260706/section_03.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-3rd',
        },
    ],
    floatingCta: {
        label: '求人一覧を見る',
        analyticsLabel: 'CT_Jobinformation_追従CTA',
    },
    jobs: {
        eyebrow: 'pickup',
        title: ['パレスホテル大宮', '求人特集'],
        analyticsLabel: 'CT_Jobinformation_求人特集-タイトル',
        categories: [
            {
                id: 'cook',
                categoryLabel: '調理スタッフ',
                description:
                    '「調理師関係功労者厚生労働大臣表彰」や「彩の国優秀技能者表彰」など受賞経験のあるシェフをはじめ、実力も折り紙付きの方々が所属しています',
                jobs: [
                    {
                        offerId: '119372',
                        badgeLabel: '料理長・料理長候補',
                        title: '高年収求人×シェフ/スーシェフ候補×新規リニューアルオープン🔍',
                        brandName:
                            'パレスホテル大宮 オールデイダイニング新店(店名未確定)',
                        brandLogo: '/features/palace-20260706/logo.jpg',
                        salary: '500~600',
                        salaryUnit: '年収',
                        prefecture: '埼玉県',
                        city: 'さいたま市大宮区',
                        image: '/features/palace-20260706/palace-card-01.jpg',
                        href: 'https://foods-labo.com/offers/119372',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理スタッフ-1st',
                    },
                    {
                        offerId: '119903',
                        badgeLabel: '料理長・料理長候補',
                        title: '【新店のシェフ候補・即戦力】大宮＊高収入＊残業代別＊母体安定＊労働環境良し',
                        brandName:
                            'パレスホテル大宮 オールデイダイニング新店(店名未確定)',
                        brandLogo: '/features/palace-20260706/logo.jpg',
                        salary: '500~600',
                        salaryUnit: '年収',
                        prefecture: '埼玉県',
                        city: 'さいたま市大宮区',
                        image: '/features/palace-20260706/palace-card-02.jpg',
                        href: 'https://foods-labo.com/offers/119903',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理スタッフ-2nd',
                    },
                    {
                        offerId: '119905',
                        badgeLabel: 'キッチンスタッフ',
                        title: '【大宮駅近く＊高収入】パレスホテルの一大プロジェクト！カフェダイニング新店',
                        brandName:
                            'パレスホテル大宮 オールデイダイニング新店(店名未確定)',
                        brandLogo: '/features/palace-20260706/logo.jpg',
                        salary: '500~600',
                        salaryUnit: '年収',
                        prefecture: '埼玉県',
                        city: 'さいたま市大宮区',
                        image: '/features/palace-20260706/palace-card-03.jpg',
                        href: 'https://foods-labo.com/offers/119905',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理スタッフ-3rd',
                    },
                    {
                        offerId: '119373',
                        badgeLabel: 'キッチンスタッフ',
                        title: '【大宮＊キッチン募集＊高収入】リニューアルオープンのオールデイダイニング',
                        brandName:
                            'パレスホテル大宮 オールデイダイニング新店(店名未確定)',
                        brandLogo: '/features/palace-20260706/logo.jpg',
                        salary: '500~600',
                        salaryUnit: '年収',
                        prefecture: '埼玉県',
                        city: 'さいたま市大宮区',
                        image: '/features/palace-20260706/palace-card-04.jpg',
                        href: 'https://foods-labo.com/offers/119373',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-調理スタッフ-4th',
                    },
                ],
            },
            {
                id: 'service',
                categoryLabel: 'サービススタッフ',
                description:
                    'リニューアルオープンを控える当ホテルのレストランのサービススタッフを募集します！',
                jobs: [
                    {
                        offerId: '120023',
                        badgeLabel: 'レストランサービス・ホールスタッフ',
                        title: '【月9日休み＊高収入＊母体安定＊アクセス抜群】大宮のカフェダイニング新店',
                        brandName:
                            'パレスホテル大宮 オールデイダイニング新店(店名未確定)',
                        brandLogo: '/features/palace-20260706/logo.jpg',
                        salary: '500~600',
                        salaryUnit: '年収',
                        prefecture: '埼玉県',
                        city: 'さいたま市大宮区',
                        image: '/features/palace-20260706/palace-card-05.jpg',
                        href: 'https://foods-labo.com/offers/120023',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-サービススタッフ-1st',
                    },
                    {
                        offerId: '119374',
                        badgeLabel: 'レストランサービス・ホールスタッフ',
                        title: 'リニューアルオープンの洋食レストランのマネジャーを募集',
                        brandName:
                            'パレスホテル大宮 オールデイダイニング新店(店名未確定)',
                        brandLogo: '/features/palace-20260706/logo.jpg',
                        salary: '500~600',
                        salaryUnit: '年収',
                        prefecture: '埼玉県',
                        city: 'さいたま市大宮区',
                        image: '/features/palace-20260706/palace-card-06.jpg',
                        href: 'https://foods-labo.com/offers/119374',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-サービススタッフ-2nd',
                    },
                    {
                        offerId: '119375',
                        badgeLabel: '料飲全般',
                        title: '新規案件の責任者候補募集！新しい挑戦を一緒にしませんか？',
                        brandName:
                            'パレスホテル大宮 オールデイダイニング新店(店名未確定)',
                        brandLogo: '/features/palace-20260706/logo.jpg',
                        salary: '500~600',
                        salaryUnit: '年収',
                        prefecture: '埼玉県',
                        city: 'さいたま市大宮区',
                        image: '/features/palace-20260706/palace-card-07.jpg',
                        href: 'https://foods-labo.com/offers/119375',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-サービススタッフ-3rd',
                    },
                ],
            },
            {
                id: 'manager',
                categoryLabel: '店長・店長候補',
                description:
                    'リニューアルレストランのオープン準備からオープン後のレストランの運営および管理をお任せいたします',
                jobs: [
                    {
                        offerId: '120024',
                        badgeLabel: '店長・店長候補',
                        title: '【カフェダイニング新店のマネージャー候補】大宮駅＊高収入＊飲食経験者歓迎',
                        brandName:
                            'パレスホテル大宮 オールデイダイニング新店(店名未確定)',
                        brandLogo: '/features/palace-20260706/logo.jpg',
                        salary: '500~600',
                        salaryUnit: '年収',
                        prefecture: '埼玉県',
                        city: 'さいたま市大宮区',
                        image: '/features/palace-20260706/palace-card-08.jpg',
                        href: 'https://foods-labo.com/offers/120024',
                        analyticsLabel: 'CT_Jobinformation_求人例-店長候補-1st',
                    },
                    {
                        offerId: '119090',
                        badgeLabel: 'マネージャー・管理職(料飲)',
                        title: 'リニューアルオープンの洋食レストランのマネジャーを募集',
                        brandName:
                            'パレスホテル大宮 オールデイダイニング新店(店名未確定)',
                        brandLogo: '/features/palace-20260706/logo.jpg',
                        salary: '500~600',
                        salaryUnit: '年収',
                        prefecture: '埼玉県',
                        city: 'さいたま市大宮区',
                        image: '/features/palace-20260706/palace-card-09.jpg',
                        href: 'https://foods-labo.com/offers/119090',
                        analyticsLabel: 'CT_Jobinformation_求人例-店長候補-2nd',
                    },
                ],
            },
        ],
    },
}
